import React, { Component } from 'react';
import defaultUser from 'public/media/images/default-profile.svg';
import { NavLink } from 'react-router-dom';
import Img from 'react-image'

class User extends Component {

	constructor(props) {

		super(props);

		//	Set image to default, after image has been completly loaded will render with the loaded image.
		this.state = { image_src: defaultUser };
		
	}

	handleImageLoaded() {

		this.setState({ image_src: this.props.info.picture });
		
	}

	renderEmptyModel = () => {
		return(
			<div key={this.props.info.id}>
				<Img src={this.state.image_src} alt="User Default" />
			</div>
		)
	}
	
	renderLiveModel = () => {
		return(
			<div key={this.props.info.id}>
				<div>
					<div>
						<NavLink to={this.props.info.link} exact>
							<Img src={this.state.image_src} alt={this.props.info.username} onLoad={this.handleImageLoaded.bind(this) } />
						</NavLink>
					</div>
				</div>
				<div className="username">{this.props.info.username}</div>
			</div>
		)
	}

	render() {
		console.log( this.props.info.picture )
		if( this.props.info.picture === "" ) {

			return(
				this.renderEmptyModel()
			);

		} else {

			return (
				this.renderLiveModel()
			);

		}

	}
	
}

export default User;


// WEBPACK FOOTER //
// ./src/components/parts/User.js